"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultElementConverters = exports.baseConverter = exports.availableConverters = exports.voidElements = exports.attachKey = void 0;
var React = require("react");
exports.attachKey = function (chunk, index) {
  if (React.isValidElement(chunk)) {
    return React.cloneElement(chunk, {
      key: chunk.key || index
    });
  }
  return chunk;
};
exports.voidElements = ['br'];
exports.availableConverters = ['br', 'strong', 'ul', 'li', 'mark', 'sup', 'h1', 'h2', 'h3', 'p', 'ol'];
exports.baseConverter = function (name, props, chunks) {
  if (props === void 0) {
    props = {};
  }
  if (chunks === void 0) {
    chunks = [];
  }
  if (exports.voidElements.includes(name)) {
    return React.createElement(name);
  }
  return React.createElement(name, props, chunks.map(exports.attachKey));
};
var defaultElementConverters = {};
exports.defaultElementConverters = defaultElementConverters;
exports.availableConverters.forEach(function (name) {
  if (exports.voidElements.includes(name)) {
    defaultElementConverters[name] = exports.baseConverter(name);
    return;
  }
  defaultElementConverters[name] = function () {
    var chunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      chunks[_i] = arguments[_i];
    }
    return exports.baseConverter(name, {}, chunks);
  };
});